import CoreService from './CoreService';

class ReportService extends CoreService {
  /* eslint-disable no-useless-constructor */
  constructor(endpoint) {
    super(endpoint);
  }

  getAvailableReports() {
    return this.api.get(`/reports/available`);
  }

  getReportsRequests() {
    return this.api.get(`/reports`);
  }

  sendReportRequest(reportName, startDate, endDate) {
    return this.api.post('/reports', {
      report_name: reportName,
      start_date: startDate,
      end_date: endDate,
    });
  }

  getDownloadLink(reportUid) {
    return this.api.get(`/reports/${reportUid}/download`);
  }
}

const instance = new ReportService('/v3');

export default instance;
